import RootStore from './rootStore';

export const rootStore = new RootStore();
